<template>
  <div class="HeaderTitle">
    <slot />
  </div>
</template>

<script>
import './style.scss'

export default {
  name: 'HeaderTitle',
}
</script>
